export const USERNAME_MIN_LENGTH = 4;
export const USERNAME_MAX_LENGTH = 32;
export const USERNAME_REGEX = /^[a-zA-Z][a-zA-Z0-9_]+$/;

export const PASSWORD_MIN_LENGTH = 6;

export const BIO_MAX_LENGTH = 2000;
